import { configConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const configs = (state = initialState, action) => {
  switch (action.type) {
    case configConstants.GET_CONFIGS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case configConstants.GET_CONFIGS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case configConstants.GET_CONFIGS_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case configConstants.GET_CONFIGS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
